/* Custom Drops - workwear band scroll reveal.
   Adds .cdw--anim (arms the hidden state) then .is-in when the section
   scrolls into view. Guarded so the content is never left invisible:
   if IntersectionObserver is missing we simply never arm the animation.
   Unobserves after firing - this plays once, not every scroll pass. */
(function () {
  function init() {
    var bands = document.querySelectorAll('.cdw');
    if (!bands.length) return;

    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    bands.forEach(function (el) {
      el.classList.add('cdw--anim');
      // Already on screen at load (short pages / deep links) - reveal next frame
      // so the transition still runs rather than snapping.
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { el.classList.add('is-in'); });
        });
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders sections without a page load.
  document.addEventListener('shopify:section:load', init);
})();
